export default __webpack_public_path__ + "static/media/ReportIcon-PatientMonitoring-MS.75c9c2cb.jpg";